import { IDictionary } from '~utilities/IDictionary';
import PropertyValuerValuationTypeEnum from '~Api/Application/PropertyValuerValuationType';

export const propertyValuerValuationTypeLabels: IDictionary<string> = {
    [PropertyValuerValuationTypeEnum.Desktop]: 'Desktop',
    [PropertyValuerValuationTypeEnum.Full]: 'Full',
};
